import { AsyncBoundary } from "@components/AsyncBoundary";
import { type ReactNode } from "react";

export const CompanionPanel = ({
  skeleton,
  fallback,
  resetKeys,
  children,
}: {
  skeleton: ReactNode;
  fallback: (retry: () => void) => ReactNode;
  resetKeys?: unknown[];
  children: ReactNode;
}) => (
  <div className="flex h-full flex-col gap-3 p-2 font-companion">
    <AsyncBoundary
      skeleton={skeleton}
      fallback={fallback}
      resetKeys={resetKeys}
    >
      {children}
    </AsyncBoundary>
  </div>
);
